export const LeagueCardSkeleton = () => {
	return (
		<div className="flex gap-6">
			{[...Array(5)].map((_, index) => (
				<div key={`league_card_skeleton_${index}`} className="h-[300px] w-[250px] shrink-0 animate-pulse rounded-md bg-gray-200">
					<div className="h-[70%] rounded-t-md bg-gray-300"></div>
					<div className="space-y-2 p-4">
						<div className="h-4 w-3/4 rounded-md bg-gray-300"></div>
						<div className="h-3 w-1/2 rounded-md bg-gray-300"></div>
					</div>
				</div>
			))}
		</div>
	);
};
